import { CSSProperties, useEffect, useState } from "react";

interface PointToasterProps {
  title: string;
  visible: boolean;
  triggerKey?: number;
}

export const PointToaster = ({
  title,
  visible,
  triggerKey,
}: PointToasterProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const displayTime = 5000;
  const isMobile = window.matchMedia("(max-width: 767px)").matches;

  const s: CSSProperties = {
    padding: "10px",
    position: "fixed",
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    color: "#fff",
    borderRadius: "5px",
    opacity: 1,
    zIndex: 1000,
    marginTop: "-50px",
    ...(isMobile
      ? {
          fontSize: "small",
        }
      : { marginLeft: "-20px" }),
  };

  useEffect(() => {
    setIsVisible(visible);
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, displayTime);
    return () => clearTimeout(timer);
  }, [visible, triggerKey, displayTime]);

  return (
    <>
      <div
        style={{
          ...s,
          display: isVisible && visible ? "block" : "none",
        }}
      >
        {title}
      </div>
    </>
  );
};
